export default __webpack_public_path__ + "static/media/Downtown.b8e8b723.webp";